module.exports = __webpack_public_path__ + "img/Globe.f0bbb0d3.svg";